import { useState } from 'react';
import {
  Container, SwipeableDrawer, List, ListItem, ListItemIcon, ListItemText, Box
} from '@mui/material';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import PersonIcon from '@mui/icons-material/Person';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import { useLocation, useNavigate } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import { logout } from '../../actions/auth';

import { useSelector, useDispatch } from 'react-redux';

const Layout = ({
  busqueda = false, search = '', buscar, ...props
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);

  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();

  const style = !location.pathname.includes("/inversiones") ?
    "container-blue-content" : ";"

  const salir = () => {
    dispatch(logout());
    navigate("/");
  }

  return (
    <div className={style}>
      <SwipeableDrawer
        anchor="left"
        open={showMenu}
        onClose={() => setShowMenu(false)}
        onOpen={() => setShowMenu(true)}
        className="aside-content"
      >
        <Box
          sx={{ width: 300 }}
          onClick={() => setShowMenu(false)}
          onKeyDown={() => setShowMenu(false)}
        >
          <div className="content">
            <img src="/logo.png" width={"90%"} />
            <List className="aside">
              {
                !user?.tipo_usuario ? (
                  <>
                    <ListItem onClick={() => navigate('datos-fiscales')} className="item-aside">
                      <ListItemIcon>
                        <PersonIcon />
                      </ListItemIcon>
                      <ListItemText primary="Datos fiscales" />
                    </ListItem>
                    <ListItem onClick={() => navigate('detalle-inversiones')} className="item-aside">
                      <ListItemIcon>
                        <ReceiptIcon />
                      </ListItemIcon>
                      <ListItemText primary="Mis Operaciones" />
                    </ListItem>
                    {user?.datos_empresas?.[0]?.status === 1 && (
                      <>
                        <ListItem onClick={() => navigate('inversiones')} className="item-aside">
                          <ListItemIcon>
                            <RequestQuoteIcon />
                          </ListItemIcon>
                          <ListItemText primary="Invertir" />
                        </ListItem>
                        <ListItem onClick={() => navigate('inversiones-con-servicio')} className="item-aside">
                          <ListItemIcon>
                            <HomeRepairServiceIcon />
                          </ListItemIcon>
                          <ListItemText primary="Contratar servicio" />
                        </ListItem>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <ListItem onClick={() => navigate('/admin/inversiones')} className="item-aside">
                      <ListItemIcon>
                        <RequestQuoteIcon />
                      </ListItemIcon>
                      <ListItemText primary="Inversiones" />
                    </ListItem>
                    <ListItem onClick={() => navigate('/admin/inversionistas')} className="item-aside">
                      <ListItemIcon>
                        <GroupIcon />
                      </ListItemIcon>
                      <ListItemText primary="Inversionistas" />
                    </ListItem>
                    <ListItem onClick={() => navigate('/admin/solicitudes')} className="item-aside">
                      <ListItemIcon>
                        <GroupIcon />
                      </ListItemIcon>
                      <ListItemText primary="Solicitudes" />
                    </ListItem>
                    <ListItem onClick={() => navigate('/admin/empresas')} className="item-aside">
                      <ListItemIcon>
                        <BusinessIcon />
                      </ListItemIcon>
                      <ListItemText primary="Empresas" />
                    </ListItem>
                  </>
                )}
              <ListItem onClick={salir} className="item-aside">
                <ListItemIcon>
                  <ExitToAppOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Cerrar sesión" />
              </ListItem>
            </List>
          </div>
        </Box>
      </SwipeableDrawer>
      <Container maxWidth="lg" sx={{ minHeight: '60vh' }}>
        <Header
          showMenu={showMenu}
          changeMenu={() => setShowMenu(!showMenu)}
        />
        {
          props.children
        }
      </Container>
      <Footer />
    </div >
  )
}

export default Layout;
